// src/services/PartnerService.js
import { useState, useEffect } from 'react';
import axios from 'axios';

const PartnerService = () => {
  const [partnerMap, setPartnerMap] = useState(new Map());

  useEffect(() => {
    const loadPartners = async () => {
      try {
        const apiUrl = process.env.REACT_APP_API_URL;
        const token = localStorage.getItem("token");

        // Fetch partners from API
        const response = await axios.get(`${apiUrl}/hms-partners/list`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        let partners = [];

        if (response.data.success && Array.isArray(response.data.partners)) {
          // Filter active partners
          partners = response.data.partners
            .filter((partner) => partner.status === "active")
            .map((partner) => ({
              value: partner.id.toString(),
              label: partner.name,
            }));
        }

        // Include static options
        const staticOptions = [
          { value: "0", label: "Walk-In" },
          { value: "1", label: "Corporate" },
        ];

        const combined = [...staticOptions, ...partners];

        // Create Map of id => name
        const map = new Map(combined.map(item => [item.value, item.label]));
        setPartnerMap(map);

        console.log(`PartnerService loaded ${map.size} entries`);

      } catch (error) {
        console.error("Error loading partners:", error);
      }
    };

    loadPartners();
  }, []);

  const getPartnerName = (partnerId) => {
    return partnerMap.get(partnerId?.toString()) || "NA";
  };

  return { getPartnerName };
};

export default PartnerService;
